import { Space as AntSpace } from 'antd'
import type { ComponentProps } from 'react'

type AntSpaceProps = ComponentProps<typeof AntSpace>

export interface AppSpaceProps extends AntSpaceProps {}

export const AppSpace = (props: AppSpaceProps) => <AntSpace {...props} />
